import { render, staticRenderFns } from "./PermissionModalTableRow.vue?vue&type=template&id=3b7182b1&scoped=true&lang=pug"
import script from "./PermissionModalTableRow.vue?vue&type=script&lang=js"
export * from "./PermissionModalTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7182b1",
  null
  
)

export default component.exports